import { render, staticRenderFns } from "./CorContractView.vue?vue&type=template&id=39574a18&"
import script from "./CorContractView.vue?vue&type=script&lang=js&"
export * from "./CorContractView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/corcontract.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports